<template>
  <div>
    <v-dialog
      v-model="filterDialog"
      width="70vw"
      height="80vh"
    >
      <v-card>
        <v-card-actions class="close-button">
          <DsButton
            v-tooltip="closeLabel"
            color="tertiary"
            name="close"
            :icon="true"
            @click="filterDialog = false"
          />
        </v-card-actions>
        <div class="internal-style">
          <MultiSelectFilter
            v-model="selectedOperators"
            class="mr-3"
            :select-items="getOptions"
            :label="operatorsLabel"
            :searchable="true"
          />
          <v-text-field
            v-model="selectedCallIds"
            class="mr-3"
            deletable-chips
            chips
            :label="callIdLabel"
          />
          <div class="buttons">
            <DsButton
              v-tooltip="filterLabel"
              class="ma-2 button"
              color="secondary"
              name="filter"
              :icon="true"
              @click="applyFilter"
            />
            <br>
            <DsButton
              v-tooltip="trashLabel"
              class="ma-2 button"
              color="secondary"
              name="trash"
              :icon="true"
              @click="resetFilter"
            />
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialog"
      width="70vw"
      height="80vh"
    >
      <v-card>
        <v-card-actions class="close-button">
          <DsButton
            v-tooltip="closeLabel"
            color="tertiary"
            name="close"
            :icon="true"
            @click="dialog = false"
          />
        </v-card-actions>
        <v-card-text class="modal-style">
          <h3>{{ this.$t('components.OperatorsLogs.faq.title') }}</h3>
          <p>{{ this.$t('components.OperatorsLogs.faq.description') }}</p>

          <h3>{{ this.$t('components.OperatorsLogs.faq2.title') }}</h3>
          <p>{{ this.$t('components.OperatorsLogs.faq2.description') }}</p>

          <h3>{{ this.$t('components.OperatorsLogs.faq3.title') }}</h3>
          <p>{{ this.$t('components.OperatorsLogs.faq3.description') }}</p>

          <h3>{{ this.$t('components.OperatorsLogs.faq4.title') }}</h3>
          <p>{{ this.$t('components.OperatorsLogs.faq4.description') }}</p>

          <h3>{{ this.$t('components.OperatorsLogs.faq5.title') }}</h3>
          <p>{{ this.$t('components.OperatorsLogs.faq5.description') }}</p>

          <h3>{{ this.$t('components.OperatorsLogs.faq8.title') }}</h3>
          <p>{{ this.$t('components.OperatorsLogs.faq8.description') }}</p>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="postDialog"
      fullscreen
    >
      <v-card>
        <v-toolbar>
          <v-toolbar-title>{{ this.$t('components.OperatorsLogs.details') }}</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <StIcon
              class="close-icon"
              icon-name="close"
              @click="closeCard()"
            />
          </v-toolbar-items>
        </v-toolbar>
        <v-card-actions>
          <PostThemeAndSentiment :post="post" />
        </v-card-actions>
      </v-card>
    </v-dialog>

    <GenericChart
      :request-status="requestStatus"
      :title="title"
      :items="exportedItems"
      :map-keys="mapKeys"
      :open-dialog="openDialog"
      :open-filter="openFilter"
      :item-id="itemId"
      :has-custom-filter="true"
      class="make-a-copy"
      v-bind="$attrs"
      @reload="getData"
    />

    <v-data-table
      :headers="headers"
      :items="items"
      :options.sync="options"
      :loading="inputLoading"
      :server-items-length="totalItems"
      :footer-props="footerProps"
      class="table-truncate"
    >
      <template v-slot:item.pid="{ item }">
        <DsButton
          v-if="item.pid"
          v-tooltip="viewLabel"
          class="clean-sla-buttons"
          color="ghost"
          name="view"
          :icon="true"
          @click="openCard({ pid: item.pid, sacCallId: item.sacCallId })"
        />
        <DsButton
          v-else
          v-tooltip="openChatLabel"
          class="clean-sla-buttons"
          color="ghost"
          name="chat"
          :icon="true"
          @click="openCard({ pid: item.pid, sacCallId: item.sacCallId })"
        />
      </template>
      <template v-slot:item.sacCallId="{ item }">
        <div
          v-tooltip="item.sacCallId"
        >
          {{ item.sacCallId || item.pid }}
        </div>
      </template>
      <template v-slot:item.username="{ item }">
        <div
          v-tooltip="item.username"
        >
          {{ item.username }}
        </div>
      </template>
      <template v-slot:item.pageChannel="{ item }">
        <div
          v-tooltip="item.pageChannel"
        >
          {{ item.pageChannel || item.channel }}
        </div>
      </template>
      <template v-slot:item.field="{ item }">
        <div
          v-tooltip="item.field"
        >
          {{ item.field }}
        </div>
      </template>
      <template v-slot:item.operation="{ item }">
        <div
          v-tooltip="item.operation"
        >
          {{ item.operation }}
        </div>
      </template>
      <template v-slot:item.newValue="{ item }">
        <div
          v-tooltip="item.newValue"
        >
          {{ item.newValue }}
        </div>
      </template>
      <template v-slot:item.oldValue="{ item }">
        <div
          v-tooltip="item.oldValue"
        >
          {{ item.oldValue }}
        </div>
      </template>
      <template v-slot:item.createdAt="{ item }">
        <div
          v-tooltip="item.createdAt"
        >
          {{ item.createdAt }}
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import GenericChart from '@/components/cards/models/GenericChart';
import PostThemeAndSentiment from '@/components/Post/PostThemeAndSentiment';
import { mapActions, mapGetters, mapState } from 'vuex';
import EventBus from '@/utils/event-bus';
import MultiSelectFilter from '../filter/MultiSelectFilter.vue';
import { DsButton } from '@ds/components';
import WarRoomService from '@/services/WarRoomService';
import moment from 'moment';
import sacTypeModel from '@/mixins/sac-type-model';
import channelModel from '@/mixins/channel-model';
import { getWarroomURL, getSmartCareURL } from '@/utils/url.js';

export default {
  name: 'ReportOperatorsLogs',
  components: {
    GenericChart,
    MultiSelectFilter,
    DsButton,
    PostThemeAndSentiment,
  },
  mixins: [
    sacTypeModel,
    channelModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      options: {
        itemsPerPage: 5,
        page: 1,
      },
      footerProps: {
        'items-per-page-options': [5, 10, 15, 20, 50],
      },
      exportLimit: 90000,
      rawItems: [],
      rawExportItems: [],
      totalItems: 0,
      requestStatus: 'loading',
      dialog: false,
      postDialog: false,
      filterDialog: false,
      post: null,
      selectedOperators: null,
      selectedCallIds: null,
    };
  },
  computed: {
    operatorsLogsMessages() {
      return this.$i18n.messages[this.$i18n.locale]?.components?.OperatorsLogs || {};
    },
    headers() {
      return [
        {
          text: this.$t('components.OperatorsLogs.username'),
          value: 'username',
        },
        {
          text: this.$t('components.OperatorsLogs.sacCallId'),
          value: 'sacCallId',
        },
        {
          text: this.$t('components.OperatorsLogs.channel'),
          value: 'pageChannel',
        },
        { text: this.$t('components.OperatorsLogs.field'), value: 'field' },
        {
          text: this.$t('components.OperatorsLogs.operation'),
          value: 'operation',
        },
        {
          text: this.$t('components.OperatorsLogs.oldValue'),
          value: 'oldValue',
        },
        {
          text: this.$t('components.OperatorsLogs.newValue'),
          value: 'newValue',
        },
        {
          text: this.$t('components.OperatorsLogs.date'),
          value: 'createdAt',
        },
        { text: this.$t('components.OperatorsLogs.viewPost'), value: 'pid' },
      ];
    },
    filterLabel() {
      return this.$t('components.OperatorsLogs.filterLabel');
    },
    trashLabel() {
      return this.$t('components.OperatorsLogs.trashLabel');
    },
    viewLabel() {
      return this.$t('components.OperatorsLogs.viewPost');
    },
    openChatLabel() {
      return this.$t('components.OperatorsLogs.openChatLabel');
    },
    closeLabel() {
      return this.$t('components.OperatorsLogs.closeLabel');
    },
    operatorsLabel() {
      return this.$t('components.OperatorsLogs.operators');
    },
    callIdLabel() {
      return this.$t('components.OperatorsLogs.sacCallIds');
    },
    mapKeys() {
      return {
        username: this.$t('components.OperatorsLogs.username'),
        sacCallId: this.$t('components.OperatorsLogs.sacCallId'),
        pageChannel: this.$t('components.OperatorsLogs.channel'),
        field: this.$t('components.OperatorsLogs.annotatedField'),
        operation: this.$t('components.OperatorsLogs.operation'),
        oldValue: this.$t('components.OperatorsLogs.oldValue'),
        newValue: this.$t('components.OperatorsLogs.newValue'),
        createdAt: this.$t('components.OperatorsLogs.date'),
      };
    },
    items() {
      return this.rawItems.map(item => this.translateItem(item));
    },
    exportedItems() {
      return this.rawExportItems.map(item => this.translateItemForExport(item));
    },
    ...mapGetters('dashboard', [
      'activeDashboardFilters',
      'activeDashboard',
    ]),
    ...mapGetters('filter', [
      'getStartDateInMilliseconds',
      'getEndDateInMilliseconds',
      'getEndDate',
    ]),
    ...mapState('filter', [
      'accountId',
      'universeId',
    ]),
    ...mapState('dashboard', [
      'isStaging',
    ]),
    inputLoading() {
      return this.requestStatus === 'loading';
    },
    getOptions() {
      return this.activeDashboardFilters?.repliers?.map(res => res.name) || [];
    },
  },
  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getOperatorsLogsService',
      'getWarroomService',
    ]),
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }
      this.getExportData();
      this.applyFilter(options);
    },
    filter() {
      if (!this.items[0]) {
        return [];
      }
      return this.items;
    },
    defaultParams() {
      const startingAt = this.getStartDateInMilliseconds;
      const endingAt = this.getEndDateInMilliseconds;
      const usernames = this.selectedOperators ? this.selectedOperators.value.join('", "') : null;
      const pids = this.selectedCallIds ? this.selectedCallIds.split(' ').join('').split(',').join('", "') : null;

      return {
        startingAt,
        endingAt,
        usernames,
        pids,
      };
    },
    async getExportData() {
      this.rawExportItems = [];
      this.getOperatorsLogsService({
        itemId: this.itemId,
        servicePath: 'getOperatorsLogs',
        serviceParams: {
          starting_at: this.defaultParams().startingAt,
          ending_at: this.defaultParams().endingAt,
          usernames: this.defaultParams().usernames,
          pids: this.defaultParams().pids,
          annotations_limit: this.exportLimit,
        },
      })
        .then(response => {
          this.rawExportItems = response.annotations;
        })
        .catch((e) => {
          console.error(e);
        });
    },
    applyFilter(options) {
      this.filterDialog = false;
      this.dialogFilter = false;
      this.requestStatus = 'loading';
      this.rawItems = [];

      this.getOperatorsLogsService({
        itemId: this.itemId,
        servicePath: 'getOperatorsLogs',
        serviceParams: {
          starting_at: this.defaultParams().startingAt,
          ending_at: this.defaultParams().endingAt,
          usernames: this.defaultParams().usernames,
          pids: this.defaultParams().pids,
          offset: (this.options.page - 1) * this.options.itemsPerPage,
          annotations_limit: this.options.itemsPerPage,
        },
      })
        .then(response => {
          this.totalItems = response.total;
          this.rawItems = response.annotations;
          this.requestStatus = 'success';
          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch((e) => {
          console.error(e);
          this.requestStatus = 'error';
        });
    },
    getTranslated(dict, key, fallback) {
      return dict[key] !== undefined ? dict[key] : fallback;
    },
    findReplierName(id) {
      const repliers = this.activeDashboardFilters.repliers || [];
      const match = repliers.find(r => r.id.toString() === id);
      return match ? match.name : '';
    },
    applyFieldValueTranslations(item, dict, originalField) {
      const fieldName = { Polarity: 'polarityTypes', Gender: 'genderTypes' }[originalField];
      if (!fieldName || !dict[fieldName]) return;
      item.newValue = this.getTranslated(dict[fieldName], item.newValue, item.newValue);
      item.oldValue = Object.prototype.hasOwnProperty.call(dict[fieldName], item.oldValue)
        ? dict[fieldName][item.oldValue]
        : item.oldValue;
    },
    applyReplierTranslations(item, dict) {
      if (item.field !== dict.answered_by && item.field !== dict.replier) return;
      item.newValue = this.findReplierName(item.newValue);
      item.oldValue = this.findReplierName(item.oldValue);
    },
    formatItemDate(timestamp) {
      const localeMap = { pt: 'pt-BR', en: 'en-US', es: 'es-ES' };
      const locale = localeMap[this.$i18n.locale] || 'pt-BR';
      return new Date(timestamp).toLocaleString(locale);
    },
    translateItem(rawItem) {
      const item = Object.assign({}, rawItem);
      const dict = this.operatorsLogsMessages;
      item.operation = this.getTranslated(dict, item.operation, item.operation);
      const originalField = item.field;
      item.field = dict[item.field.toLowerCase()] || item.field;
      item.newValue = item.newValue.toString();
      item.oldValue = item.oldValue.toString();
      this.applyFieldValueTranslations(item, dict, originalField);
      this.applyReplierTranslations(item, dict);
      item.createdAt = this.formatItemDate(rawItem.createdAt);
      return item;
    },
    translateItemForExport(rawItem) {
      const item = Object.assign({}, rawItem);
      const dict = this.operatorsLogsMessages;
      item.operation = this.getTranslated(dict, item.operation, item.operation);
      const originalField = item.field;
      item.field = dict[item.field.toLowerCase()] || item.field;
      this.applyFieldValueTranslations(item, dict, originalField);
      this.applyReplierTranslations(item, dict);
      item.createdAt = this.formatItemDate(rawItem.createdAt);
      return item;
    },
    resetFilter() {
      this.selectedOperators = null;
      this.selectedCallIds = null;
      this.applyFilter();
    },
    openDialog() {
      this.dialog = true;
    },
    openFilter() {
      this.filterDialog = true;
    },
    async openCard({ pid, sacCallId }) {
      if (!pid) {
        return this.encodeFilter(sacCallId);
      }
      this.$attrs.filter = { pids: [pid] };
      this.$attrs.filterId = null;
      const defaultParams = {
        date_range: `200001010000:${this.getEndDate}`,
        account_id: this.accountId,
        universe_id: this.universeId,
        is_staging: this.isStaging,
        limit: 1,
        filter: {
          pages: {
            value: this.activeDashboard.data.pages.map(page => page.id),
          },
          channels: {
            value: Object.values(this.channelsList),
          },
        },
      };
      pid ? (defaultParams.filter.pids = { value: [pid] }) : (defaultParams.filter.sac_call_ids = { value: [sacCallId] });
      WarRoomService.topPosts({ params: defaultParams })
        .then(res => {
          if (!res.posts[0]) {
            this.postDialog = false;
          } else {
            this.postDialog = true;
            this.post = res.posts[0];
          }
        }).catch(err => console.error(err));
    },
    async encodeFilter(sacCallId) {
      const newCardFilter = {
        sac_call_ids: {
          value: [
            sacCallId,
          ],
        },
        pages: {
          value: this.activeDashboard.data.pages.map(page => page.id),
        },
        channels: {
          value: Object.values(this.channelsList),
        },
        sac_type: {
          value: Object.keys(this.sacTypeList),
        },
        is_sac: true,
      };
      const filterId = await WarRoomService.encodeFilter({
        account_id: this.accountId,
        is_staging: this.isStaging,
        filter: JSON.stringify(newCardFilter),
      });
      const endingAt = moment().endOf('day').format('YYYYMMDDHHmm');
      const dateRange = `200001010000:${endingAt}`;
      const activatePanelURL = getWarroomURL(this.isStaging, this.accountId, this.universeId);
      const smartCareURL = getSmartCareURL(this.isStaging, dateRange, filterId);
      window.open(activatePanelURL, '_blank').location.replace(smartCareURL);
    },
    closeCard() {
      this.postDialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.v-select__selection.v-select__selection--comma {
  line-height: 120%;
}

.internal-style {
  width: 100%;
  padding: 1rem;
  display: flex;
}

.buttons {
  display: flex;
}

.button {
  box-shadow: none;
  border-radius: unset;
}

.close-button {
  display: flex;
  flex: end;
  justify-content: flex-end;
}

.clean-sla-buttons {
  box-shadow: none;
  border-radius: unset;
}

::v-deep {
  .table-truncate {
    td {
      max-width: 10vw;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .modal-style {
    * {
      color: var(--ds-color-snow) !important;
    }

    h3 {
      font-weight: var(--ds-font-weight-bold);
    }
  }

  .close-icon {
    height: var(--ds-spacing-stack-lg);
    padding-top: var(--ds-spacing-stack-lg);
  }

  .v-dialog {
    overflow-x: hidden;
  }
}
</style>
